import LoyaltyProgramPage from './loyaltyProgram.container';

export default LoyaltyProgramPage;